/**
 * Estado de evaluación del enrol
 * Corresponde al campo evaluation_state en el modelo Enrol del backend
 * @see lms-api/app/enumerations/evaluation_state.rb
 */
export enum EnrolEvaluationState {
  Pending = 0,
  Approved = 1,
  Failed = 2,
}
